export const environment = {
  production: false,
  apiUrl: 'https://api.mdgestaoemsaude.com.br/api/',
  wsUrl: 'wss://api.mdgestaoemsaude.com.br/ws/',
  // wsUrl: 'ws://localhost:8080/ws/',
  // apiUrl: 'http://localhost:8080/api/',
  viaCep: '//viacep.com.br/ws',

  companyName: 'MD Gestao em Saude',
  companyId: '679ae7b68ea4a40d26065263',
  logoUrl: 'assets/img/companies/md/logo.png',
  faviconUrl: 'assets/img/companies/md/favicon.ico',
  urlRegisterProfessional: 'https://inscricao.mdgestaoemsaude.com.br/',
  colors: {
    heraBlueColor: '#3D9998',
    aareRiverColor: '#00b69b',
    blackColor: '#260944',
    paragraphColor: '#5b5b98',
  },
};
